import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import { getThemeColor } from "../utils";
import SignupForm from "./SignupForm";

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 22rem;
  background-color: ${getThemeColor("purpleDark")};

  ${props => props.theme.media.mobile`
    padding: 3rem 2rem;
  `};

  ${props => props.theme.media.tablet`
    padding: 4rem 2rem;
  `};
`;

const Disclosure = styled.div`
  width: 100%;
  text-align: center;
  color: #999;
  font-size: 0.65rem;
  line-height: 1.4;
  padding: 1.5rem 2rem 1.25rem;
  max-width: 48rem;
`;

const FooterContent = styled.div`
  flex: 1;
  width: 100%;
  max-width: 72rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavigationLinks = styled.div`
  display: flex;
  flex-direction: column;
`;

const Line = styled.div`
  margin-bottom: 0.3125rem;
  padding: 0.15625rem 0;
  min-width: 1rem;
  width: 1.5rem;
  background: ${getThemeColor("white")};
`;

const NavigationLink = styled(Link)`
  line-height: 1.4;
  margin-top: 0.3125rem;
  margin-bottom: 0.3125rem;
  color: ${getThemeColor("white")};
  font-weight: 500;
  text-decoration: none;
`;

const LegalLink = styled(Link)`
  text-align: right;
  line-height: 1.4;
  margin-top: 0.3125rem;
  margin-bottom: 0.3125rem;
  color: ${getThemeColor("grey")};
  font-weight: 400;
  font-size: 0.75rem;
  text-decoration: none;
`;

const Copyright = styled.div`
  text-align: end;
  line-height: 1.125rem;
  color: ${getThemeColor("grey")};
  font-size: 0.75rem;
  font-weight: 500;
`;

const Address = styled.div`
  text-align: right;
  line-height: 1.125rem;
  padding-bottom: 0.5rem;
  color: ${getThemeColor("white")};
  font-weight: 500;
`;

const SubscribeAndCopyright = styled.div`
  display: inline-grid;
  padding-top: 2.8125rem;
  padding-right: 0.5rem;

  ${props => props.theme.media.mobile`
    width 9.375rem;
    width: auto;
    flex: 1;
    padding-left: 3rem
  `};
`;

export default () =>
  <Footer>
    <FooterContent>
      <NavigationLinks>
        <Line />
        <NavigationLink to="/trials">Pipeline</NavigationLink>
        <NavigationLink to="/mission">Mission</NavigationLink>
        <NavigationLink to="/team">Team</NavigationLink>
        <NavigationLink to="/news">News</NavigationLink>
        <NavigationLink to="/careers">Careers</NavigationLink>
        <NavigationLink to="/participate">Participate</NavigationLink>
        <NavigationLink to="/contact">Contact</NavigationLink>
      </NavigationLinks>
      <SubscribeAndCopyright>
        <SignupForm />
        <Address>
          {"818 E. Jefferson St. Suite 201, Charlottesville, VA 22902"}
        </Address>
        <Copyright>
          © {1900 + new Date().getYear()} Contraline, Inc. All Rights Reserved.
        </Copyright>
        <div style={{ textAlign: "right" }}>
          <LegalLink to="/privacy">Privacy policy</LegalLink>
          <span style={{ color: "#999", fontSize: "0.75rem", margin: "0 0.4rem" }}>&middot;</span>
          <LegalLink to="/coi-policy">FCOI policy</LegalLink>
        </div>
      </SubscribeAndCopyright>
    </FooterContent>
    <Disclosure>
      Contraline&rsquo;s products are investigational and have not been approved by the U.S. Food and Drug Administration (FDA) or any other regulatory authority.
    </Disclosure>
  </Footer>;



// WEBPACK FOOTER //
// ./src/components/Footer.js